/**
 * IMPORTANT: in the themeui file, `color` will be converted to CSS classes like --theme-ui-colors-some-color
 * Because we don't want to use the entire var name within each color reference, this helper will convert the variable name,
 * which should be present within the colors.$var section.
 * @param variableName
 */
export const themeColor = (variableName: string): string =>
  `var(--theme-ui-colors-${variableName.split(".").join("-")})`;
